"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var redux_1 = require("redux");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var Reducers = {
    // Store profile-specific preferences: { [profileId]: { selectedCategoryId, ... } }
    byProfileId: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_PREFERENCE] = function (state, action) {
            var _a = action.payload, profileId = _a.profileId, key = _a.key, value = _a.value;
            if (!profileId) {
                return;
            }
            // Initialize profile preferences if not exists
            if (!state[profileId]) {
                state[profileId] = {};
            }
            state[profileId][key] = value;
        },
        _a[constants_1.SET_SELECTED_CATEGORY_ID] = function (state, action) {
            var _a = action.payload, profileId = _a.profileId, categoryId = _a.categoryId;
            if (!profileId) {
                return;
            }
            // Initialize profile preferences if not exists
            if (!state[profileId]) {
                state[profileId] = {};
            }
            state[profileId].selectedCategoryId = categoryId;
        },
        _a[constants_1.CLEAR_PREFERENCES] = function (state, action) {
            var profileId = action.payload.profileId;
            if (profileId && state[profileId]) {
                delete state[profileId];
            }
        },
        _a), {}),
};
exports.default = redux_1.combineReducers(Reducers);
//# sourceMappingURL=reducer.js.map